export default __webpack_public_path__ + "static/media/statusNew.d6d37bf1.svg";